window.PlummeI18n.register('no', {
  "clo.focus.finalConfirmation": "Jeg har kontrollert grunnlaget, egenkapitalhendelser, etterfølgende hendelser og fortsatt drift. Alle nødvendige posteringer og vurderinger er avklart. Jeg godkjenner at året avsluttes. Godkjenner og tidspunkt lagres i historikken.",
  "clo.focus.approve": "Godkjenn",
  "clo.focus.startYear": "Oppstartsår for regnskapet",
  "clo.focus.bankSetupMissing": "Registrer oppstartsdato og dokumentert startsaldo i kontooppsettet nedenfor. Skriv 0 dersom saldoen var null.",
  "clo.focus.bankStatements": "Kontoutskrifter mangler for periodene",
  "clo.focus.bankUnsettled": "Perioder må avstemmes",
  "clo.focus.bankDifferences": "Saldoavvik må avklares i bankavstemmingen.",
  "clo.focus.bankUnconfigured": "Opprett bankkonto med riktig regnskapskonto for disse bokførte saldoene",
  "clo.focus.reconcile": "Fullfør avstemming",
  "clo.focus.restore": "Gjenopprett størrelse",
  "clo.focus.fullscreen": "Fullskjerm",
  "clo.focus.notCalculated": "Ikke beregnet",
  "clo.focus.taxScope": "Avklar skatteregime",
  "clo.focus.rateHelp": "Ordinær norsk selskapsskatt er 22 % fra 2019. Bekreft skatteregimet før beregningen kan godkjennes. Finansskatt og særregimer krever egen vurdering.",
  "clo.focus.industry": "Skatteregime",
  "clo.focus.ordinary": "Ordinært skatteregime",
  "clo.focus.special": "Særregime – krever vurdering",
  "clo.focus.finance": "Finansskattepliktig",
  "clo.focus.priorLoss": "Fremførbart underskudd fra tidligere år (bekreft også 0)",
  "clo.focus.updateCalculation": "Lagre og beregn",
  "clo.focus.taxCalculation": "Slik beregnes skatten",
  "clo.focus.resultBeforeTax": "Resultat før skatt",
  "clo.focus.permanent": "+ Permanente forskjeller (netto)",
  "clo.focus.temporaryChange": "− Endring i midlertidige forskjeller",
  "clo.focus.lossApplied": "− Benyttet fremførbart underskudd",
  "clo.focus.taxable": "= Skattegrunnlag",
  "clo.focus.rate": "Skattesats",
  "clo.focus.resolveRate": "Avklar skatteregime ovenfor",
  "clo.focus.payable": "= Betalbar skatt",
  "clo.focus.lossRemaining": "Underskudd til fremføring",
  "clo.focus.deferredTax": "Utsatt skatt / skattefordel",
  "clo.focus.temporary": "Midlertidige forskjeller",
  "clo.focus.unrecognized": "Ikke balanseført skattefordel (grunnlag)",
  "clo.focus.deferredBasis": "Grunnlag for utsatt skatt",
  "clo.focus.deferredAmount": "Utsatt skatt / skattefordel",
  "clo.focus.postingApproval": "Godkjenn beregning og sluttpostering",
  "clo.focus.postingHelp": "Godkjenningen bekrefter at du har kontrollert skattegrunnlag, forskjeller og fremførbart underskudd. Betalbar skatt og eventuell endring i utsatt skatt bokføres ved avslutning av regnskapsåret. Allerede bokførte beløp hensyntas av sluttposteringen.",
  "clo.focus.postingAccounts": "Beregnet betalbar skatt: debet 8300 / kredit 2500",
  "clo.focus.reviewRequired": "Skatteregime eller særskilte skatteforhold må avklares før godkjenning.",
  "clo.focus.unsaved": "Lagre og beregn etter endringer før du godkjenner.",
  "clo.focus.editDifferences": "Endre forskjeller og spesifikasjoner",
  "clo.checklist.custom.mappedDetail": "Ingen kontoer mangler kobling til Plummes standardkontoplan. Importerte kontoer kontrolleres når de inngår i kontoplanen. Dette er ikke en kontroll av hele skattemeldingskoblingen.",
  "clo.priorYear.closedDetail": "Regnskapsåret {{year}} er avsluttet.",
  "clo.priorYear.noActivity": "Ingen regnskapstall er registrert for {{year}} i Plumme. Oppstartsår alene avgjør ikke om forrige år må avsluttes.",
  'clo.wealth.bookBasisNotice': "Foreløpig oversikt fra regnskapet. Beløpene er bokførte verdier, ikke ferdig beregnede skattemessige formuesverdier.",
  'clo.wealth.fixedAssetComparison': "Eiendelsregisteret: bokført verdi {{book}}, skattemessig saldo {{tax}}. Forskjell {{difference}} (bokført minus skattemessig). Skattemessig saldo er ikke automatisk formuesverdi.",
  'clo.finalSummary.permanentAmount': "Permanente forskjeller",
  'clo.finalSummary.temporaryAmount': "Midlertidige forskjeller ved årsslutt",
  'clo.balanceGroup.vatReceivable': "MVA til gode",
  'clo.balanceGroup.debitReceivable': "Fordring – debetsaldo {{code}}",
});
